import { getGridSummaryCount, renderGridSummarySum, renderGridSummarySumTonnes, renderGridSummarySumHL } from 'components/global/utils';
import { CustomerReportGridData } from '@pages/reporting-pages/deliveries-customer/types/CustomerReportGridData';



interface GridSummaryProps<T> {
	data?: T[] | null,
}


const GridSummary = (props: GridSummaryProps<CustomerReportGridData>) => {
	const { data } = props;

	return (
		<>
			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
				<p>{getGridSummaryCount(data)}</p>
			</div>


			<div className='app-grid-summary'>
				<p>{renderGridSummarySumHL(data, 'total_volume')}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySumTonnes(data, 'total_weight')}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySumTonnes(data, 'total_returnsWeight')}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySum(data, 'total_ordersCount')}</p>
			</div>

		</>
	)
}

export default GridSummary;